'use strict';


module.exports = function (client) {

    client.disco.addFeature('urn:xmpp:json:0');
};



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/stanza.io/lib/plugins/json.js
// module id = 615
// module chunks = 2